/* app/ui/map/map.interactive */

define(
	'app/ui/map/map.interactive',[
		'jquery',
		'app/ui/map/map.styles',
		'templayed',
		'text!templates/infowindow.html',
		'markerclusterer',
		'pubsub'
	],
	function ($, MapStyles, templayed, infoWindowTemplate) {

		window.dataLayer = window.dataLayer || [];

		var Module;
		var MapLoad;

		var $map;
		var gMap;
		var feedData;
		var feedDataLoaded = false;
		var infobox;
		var mapLimits;
		var markers = [];
		var markerCluster;
		var itinerary;
		var operatorMap;

		return {
			init: function($elm, loadModule) {
				Module = this;
				MapLoad = loadModule;

				$map = $elm;
				infoWindowTemplate = infoWindowTemplate.replace(/\r/g, '');

				Module._initSubscriptions();
			},

			_initSubscriptions: function () {
				$.subscribe('/map/interactive/opened', Module._loadDependencies);
				$.subscribe('/map/apiLoaded', Module._loadMap);
				$.subscribe('/operator/feed/loaded', Module._loadFeed);
			},

			_loadDependencies: function() {
				var apiStatus = MapLoad.getMapApiStatus();

				if (!apiStatus.loaded) {
					MapLoad.loadApi();
				}
			},

			_loadMap: function() {

				var mapCanvas = $map[0];
				var latLng = new google.maps.LatLng(-38.69055413, 176.08227233);
				var mapOptions = {
					zoom: 10,
					center: latLng,
					streetViewControl: false,
					scrollwheel: false,
					mapTypeControl: false,
					panControl: false,
					zoomControl: true,
					zoomControlOptions: {
						style: google.maps.ZoomControlStyle.LARGE,
						position: google.maps.ControlPosition.LEFT_BOTTOM
					},
					styles: MapStyles
				};

				var infoboxOptions = {
					boxClass: 'c-infowindow',
					alignBottom: true,
					pixelOffset: new google.maps.Size(-145, -25),
					closeBoxURL: '/Content/images/interface/icon-close.png',
					closeBoxMargin: '0',
					disableAutoPan: true,
					boxStyle: {
						width: '290px',
						padding: '0px 0px 0px 0px'
					}
				};

				require(['infobox'],
					function () {
						infobox = new InfoBox(infoboxOptions);
					}
				);

				gMap = new google.maps.Map(mapCanvas, mapOptions);
				mapLimits = new google.maps.LatLngBounds({ lat: -39.87601352, lng: 174.11124375 },
					{ lat: -38.15183136, lng: 177.64884141 });

				Module._populateMap();
				$.subscribe('/operator/list/mouseevent', Module._processMouseEvent);
			},

			_loadFeed: function (data) {

				feedData = data;
				feedDataLoaded = true;

				if (Array.isArray(feedData) === false) {
					feedData = [feedData];
				}
				// check if map is itinerary map
				if (data.itinerary) {
					itinerary = true;
				}
				if (data.operatorMap) {
					operatorMap = true;
				}

				if (typeof gMap === 'object') {
					// TODO: Update this to work with an array of marker clusters
					
					if (!itinerary && !operatorMap) {
						markerCluster.clearMarkers();
					}
					
					markers = [];
					Module._populateMap();
				}
			},

			_populateMap: function() {
				var bounds = new google.maps.LatLngBounds();

				if (!feedDataLoaded) {
					window.setTimeout(
						function () {
							Module._populateMap();
						},
						500
					);
					return;
				}

				for (var i = 0; i < feedData.length; i++) {
					var group = feedData[i];
					var icon = '/Content/images/interface/marker-sm.png';
					var markerPath = 'm';

					if (itinerary) {
						icon = '/Content/images/interface/map/day-' + (i + 1) + '/marker-sm.png';
						markerPath = 'map/day-' + (i + 1) + '/m';
					}

					for (var j = 0; j < group.Listings.length; j++) {
						var feedItem = group.Listings[j];
						var latLng = {
							lat: parseFloat(feedItem.latitude, 10),
							lng: parseFloat(feedItem.longitude, 10)
						};
						var marker = new google.maps.Marker({
							position: latLng,
							icon: icon,
							map: gMap,
							title: feedItem.Title,
							dataGroupIndex: i,
							dataIndex: j
						});

						if (mapLimits.contains(latLng)) {
							markers.push(marker);
							marker.addListener('click', Module._getInfoContent);
							bounds.extend(marker.getPosition());
						}
					}

					if (!itinerary && !operatorMap) {

						markerCluster = new MarkerClusterer(gMap, markers,
							{
								gridSize: 30,
								styles: Module._getMarkerClusterOptions(markerPath)
							});

						google.maps.event.addListener(markerCluster, 'clusterclick', Module._trackClickCluster);

					} 

					// click map to hide infobox
					google.maps.event.addListener(gMap, 'click', function () {
						infobox.close();
					});
					
				}

				$.subscribe('/map/fitBounds', function () {
					gMap.fitBounds(bounds);
				});
				$.publish('/map/fitBounds');
			},

			_getMarkerClusterOptions: function (path) {
				path = path || 'm';

				var options = [
					{
						width: 53,
						height: 52,
						url: '/Content/images/interface/' + path + '/1.png',
						textColor: '#ffffff'
					},
					{
						width: 56,
						height: 55,
						url: '/Content/images/interface/' + path + '/2.png',
						textColor: '#ffffff'
					},
					{
						width: 66,
						height: 65,
						url: '/Content/images/interface/' + path + '/3.png',
						textColor: '#ffffff'
					},
					{
						width: 78,
						height: 77,
						url: '/Content/images/interface/' + path + '/4.png',
						textColor: '#ffffff'
					},
					{
						width: 90,
						height: 89,
						url: '/Content/images/interface/' + path + '/5.png',
						textColor: '#ffffff'
					}
				];

				return options;
			},

			_processMouseEvent: function(data) {
				var $tile = data.tile;
				var action = data.action;
				var tileIndex = parseInt($tile.data('feed-index'), 10);
				var marker = markers[tileIndex];
				if (marker) {
					if (action === 'mouseenter') {
						marker.setAnimation(google.maps.Animation.BOUNCE);
					} else {
						marker.setAnimation(null);
					}
				}
			},

			_getInfoContent: function() {
				var feedItem = Module._getMarkerInfo(this);
				var compiledHtml = templayed(infoWindowTemplate)(feedItem);
				var $content = document.createElement('div');
				var $link;

				$content.innerHTML = compiledHtml;

				Module._trackClickMarker(feedItem.Title);

				infobox.setContent($content);

				$link = $content.querySelector('.js-gtm-map-detail-click');
				google.maps.event.addDomListener($link, 'click', Module._trackDetailClick);

				infobox.open(this.map, this);
				this.map.panTo(infobox.getPosition());
			},

			_getMarkerInfo: function (marker) {
				var markerInfo = feedData[marker.dataGroupIndex].Listings[marker.dataIndex];

				return markerInfo;
			},

			_trackClickCluster: function () {
				window.dataLayer.push({
					'event': 'customEvent',
					'eventData': {
						'category': 'Operator Map',
						'action': 'Click Cluster',
						'label': document.location.href
					}
				});
			},
			_trackClickMarker: function (operatorName) {
				window.dataLayer.push({
					'event': 'customEvent',
					'eventData': {
						'category': 'Operator Map',
						'action': 'Click Marker',
						'label': 'Operator: ' + operatorName + ', Page: ' + document.location.href
					}
				});
			},
			_trackDetailClick: function (e) {
				var $link = $(e.target);
				var operatorName = $link.text();

				window.dataLayer.push({
					'event': 'customEvent',
					'eventData': {
						'category': 'Operator Map',
						'action': 'Detail Click',
						'label': 'Operator: ' + operatorName + ', Page: ' + document.location.href
					}
				});
			}
		};
	}
);
